import { ActionTypes } from "../actions/actionTypes";
import { WidgetActions } from "../actions/widgetActions";
import { WidgetsState } from "../states/widgetsState";
import { getGridColumns, getReactGridLayoutArray, getWidgetLayoutType, getWidgetsAfterResize, setCurrentLayout, updateWidgetsOnDragStop } from "../utilities/widgetHelper";

export const initialState: WidgetsState = {
    widgets: [],
    widgetsLayout: [],
    error: undefined,
    widgetsContainerWidth: 1481,
    windowWidth: 1920,
    gridColumns: 12,
    windowWidthChanged: 1,
    addWidgetNotification: undefined
};

export default function reducer(state: WidgetsState = initialState, action: WidgetActions): WidgetsState {
    switch (action.type) {
      case ActionTypes.SAVE_WIDGETS_SUCCESS: {
        return {
            ...state,
            widgets: action.payload.widgets,
            widgetsLayout: action.payload.widgetsLayout,
        };
      }
      case ActionTypes.SAVE_WIDGETS_FAILURE: {
        return {
          ...state,
          error: action.payload
        };
      }
      case ActionTypes.ON_DRAG_STOP: {
        const updatedWidgets = updateWidgetsOnDragStop(state.widgets, action.payload);
        const widgetsLayout = getReactGridLayoutArray(updatedWidgets);
        return {
          ...state,
          widgets: updatedWidgets,
          widgetsLayout: widgetsLayout,
        };
      }
      case ActionTypes.ON_WIDGET_RESIZE: {
        const widgets = getWidgetsAfterResize(state.widgets, action.payload, state.windowWidth);
        const layout = getReactGridLayoutArray(widgets);
        return {
          ...state,
          widgets: widgets,
          widgetsLayout: layout,
        };
      }
      case ActionTypes.WINDOW_WIDTH_CHANGED: {
        if (state.widgetsContainerWidth === action.payload.containerWidth) {
          return state;
        }
        const currentLayoutType = getWidgetLayoutType(state.windowWidth);
        const newLayoutType = getWidgetLayoutType(action.payload.windowWidth);
        const gridColumns = getGridColumns(action.payload.windowWidth);
        if (currentLayoutType === newLayoutType) {
          return {
            ...state,
            windowWidth: action.payload.windowWidth,
            widgetsContainerWidth: action.payload.containerWidth,
            gridColumns: gridColumns,
            windowWidthChanged: (state.windowWidthChanged ?? 1) + 1
          };          
        }
        
        const updatedWidgets = setCurrentLayout(state.widgets, action.payload.windowWidth);
        const widgetsLayout = getReactGridLayoutArray(updatedWidgets);
        return {
          ...state,
          widgets: updatedWidgets,
          widgetsLayout: widgetsLayout,
          windowWidth: action.payload.windowWidth,
          widgetsContainerWidth: action.payload.containerWidth,
          gridColumns: gridColumns,
          windowWidthChanged: (state.windowWidthChanged ?? 1) + 1
        };
      }
      case ActionTypes.SET_ADD_WIDGET_NOTIFICATION: {
        return {
            ...state,
            addWidgetNotification: action.payload
        };
      }
    }
    return state;
}